import qs from "qs"

export const convertUnencodedParamStringToObject = (unencodedParamString: string) =>
    qs.parse(unencodedParamString, {
        decoder: (str) => str,
    })

export const serializeParams = (params: Record<string, any>) => qs.stringify(params, { encode: true, arrayFormat: "comma" })
